/* eslint-disable max-lines */
import type { SupportCategory, SupportSubcategory, SupportSubcategoryQuestion } from './types';

export const MARKETING_CATEGORIES: SupportCategory[] = [
  { id: 'mkt-canva', label: 'Canva', departmentId: 'Marketing' },
  { id: 'mkt-tours', label: 'Tours', departmentId: 'Marketing' },
  { id: 'mkt-materials', label: 'Marketing Materials', departmentId: 'Marketing' },
];

export const MARKETING_SUBCATEGORIES: SupportSubcategory[] = [
  { id: 'mkt-canva-flyers', label: 'Flyers', categoryId: 'mkt-canva' },
  { id: 'mkt-canva-instagram', label: 'Instagram Template', categoryId: 'mkt-canva' },
  { id: 'mkt-canva-other', label: 'Other', categoryId: 'mkt-canva' },
  { id: 'mkt-tours-business-cards', label: 'Business Cards', categoryId: 'mkt-tours' },
  { id: 'mkt-tours-folders', label: 'Tour folders', categoryId: 'mkt-tours' },
  { id: 'mkt-tours-pamphlets', label: 'Pamphlets', categoryId: 'mkt-tours' },
  { id: 'mkt-tours-trifolds', label: 'Trifolds', categoryId: 'mkt-tours' },
  { id: 'mkt-materials-vouchers', label: 'Vouchers', categoryId: 'mkt-materials' },
  { id: 'mkt-materials-physical-flyers', label: 'Physical Flyers', categoryId: 'mkt-materials' },
  { id: 'mkt-materials-partnerships', label: 'Partnerships', categoryId: 'mkt-materials' },
  { id: 'mkt-materials-email', label: 'Email', categoryId: 'mkt-materials' },
  { id: 'mkt-materials-merchandise', label: 'Marketing Merchandise', categoryId: 'mkt-materials' },
];

export const MARKETING_QUESTIONS: SupportSubcategoryQuestion[] = [
  {
    id: 'mkt-canva-flyers-1',
    subcategoryId: 'mkt-canva-flyers',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'mkt-canva-flyers-2',
    subcategoryId: 'mkt-canva-flyers',
    type: 'textarea',
    label: 'Description',
    required: true,
  },
  {
    id: 'mkt-canva-flyers-3',
    subcategoryId: 'mkt-canva-flyers',
    type: 'date',
    label: 'When do you need this by?',
    required: true,
  },
  {
    id: 'mkt-canva-flyers-4',
    subcategoryId: 'mkt-canva-flyers',
    type: 'file',
    label: 'Select A File',
    required: false,
  },
  {
    id: 'mkt-canva-instagram-1',
    subcategoryId: 'mkt-canva-instagram',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'mkt-canva-instagram-2',
    subcategoryId: 'mkt-canva-instagram',
    type: 'textarea',
    label: 'Description',
    required: true,
  },
  {
    id: 'mkt-canva-instagram-3',
    subcategoryId: 'mkt-canva-instagram',
    type: 'date',
    label: 'When do you need this by?',
    required: true,
  },
  {
    id: 'mkt-canva-instagram-4',
    subcategoryId: 'mkt-canva-instagram',
    type: 'file',
    label: 'Select A File',
    required: false,
  },
  {
    id: 'mkt-canva-other-1',
    subcategoryId: 'mkt-canva-other',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'mkt-canva-other-2',
    subcategoryId: 'mkt-canva-other',
    type: 'textarea',
    label: 'Description',
    required: true,
  },
  {
    id: 'mkt-canva-other-3',
    subcategoryId: 'mkt-canva-other',
    type: 'text',
    label: 'What is this for?',
    required: true,
  },
  {
    id: 'mkt-canva-other-4',
    subcategoryId: 'mkt-canva-other',
    type: 'date',
    label: 'When do you need this by?',
    required: true,
  },
  {
    id: 'mkt-canva-other-5',
    subcategoryId: 'mkt-canva-other',
    type: 'file',
    label: 'Select A File',
    required: false,
  },
  {
    id: 'mkt-tours-cards-1',
    subcategoryId: 'mkt-tours-business-cards',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'mkt-tours-cards-2',
    subcategoryId: 'mkt-tours-business-cards',
    type: 'text',
    label: 'First and Last name of person card is needed for',
    required: true,
  },
  {
    id: 'mkt-tours-cards-3',
    subcategoryId: 'mkt-tours-business-cards',
    type: 'text',
    label: 'Job Title',
    required: true,
  },
  {
    id: 'mkt-tours-cards-4',
    subcategoryId: 'mkt-tours-business-cards',
    type: 'text',
    label: 'Amount Needed',
    required: true,
  },
  {
    id: 'mkt-tours-cards-5',
    subcategoryId: 'mkt-tours-business-cards',
    type: 'date',
    label: 'Needed by',
    required: true,
  },
  {
    id: 'mkt-tours-cards-6',
    subcategoryId: 'mkt-tours-business-cards',
    type: 'textarea',
    label: 'Anything else I need to know',
    required: false,
  },
  {
    id: 'mkt-tours-cards-7',
    subcategoryId: 'mkt-tours-business-cards',
    type: 'file',
    label: 'Select A File',
    required: false,
  },
  {
    id: 'mkt-tours-folders-1',
    subcategoryId: 'mkt-tours-folders',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'mkt-tours-folders-2',
    subcategoryId: 'mkt-tours-folders',
    type: 'textarea',
    label: 'Description',
    required: true,
  },
  {
    id: 'mkt-tours-folders-3',
    subcategoryId: 'mkt-tours-folders',
    type: 'text',
    label: 'Amount Needed',
    required: true,
  },
  {
    id: 'mkt-tours-folders-4',
    subcategoryId: 'mkt-tours-folders',
    type: 'date',
    label: 'Needed by',
    required: true,
  },
  {
    id: 'mkt-tours-folders-5',
    subcategoryId: 'mkt-tours-folders',
    type: 'textarea',
    label: 'Anything else I need to know',
    required: false,
  },
  {
    id: 'mkt-tours-folders-6',
    subcategoryId: 'mkt-tours-folders',
    type: 'file',
    label: 'Select A File',
    required: false,
  },
  {
    id: 'mkt-tours-pamphlets-1',
    subcategoryId: 'mkt-tours-pamphlets',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'mkt-tours-pamphlets-2',
    subcategoryId: 'mkt-tours-pamphlets',
    type: 'textarea',
    label: 'Description',
    required: true,
  },
  {
    id: 'mkt-tours-pamphlets-3',
    subcategoryId: 'mkt-tours-pamphlets',
    type: 'text',
    label: 'Amount Needed',
    required: true,
  },
  {
    id: 'mkt-tours-pamphlets-4',
    subcategoryId: 'mkt-tours-pamphlets',
    type: 'date',
    label: 'Needed by',
    required: true,
  },
  {
    id: 'mkt-tours-pamphlets-5',
    subcategoryId: 'mkt-tours-pamphlets',
    type: 'textarea',
    label: 'Anything else I need to know',
    required: false,
  },
  {
    id: 'mkt-tours-trifolds-1',
    subcategoryId: 'mkt-tours-trifolds',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'mkt-tours-trifolds-2',
    subcategoryId: 'mkt-tours-trifolds',
    type: 'textarea',
    label: 'Description',
    required: true,
  },
  {
    id: 'mkt-tours-trifolds-3',
    subcategoryId: 'mkt-tours-trifolds',
    type: 'text',
    label: 'Amount Needed',
    required: true,
  },
  {
    id: 'mkt-tours-trifolds-4',
    subcategoryId: 'mkt-tours-trifolds',
    type: 'date',
    label: 'Needed by',
    required: true,
  },
  {
    id: 'mkt-tours-trifolds-5',
    subcategoryId: 'mkt-tours-trifolds',
    type: 'textarea',
    label: 'Anything else I need to know',
    required: false,
  },
  {
    id: 'mkt-materials-vouchers-1',
    subcategoryId: 'mkt-materials-vouchers',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'mkt-materials-vouchers-2',
    subcategoryId: 'mkt-materials-vouchers',
    type: 'text',
    label: 'What is this needed for',
    required: true,
  },
  {
    id: 'mkt-materials-vouchers-3',
    subcategoryId: 'mkt-materials-vouchers',
    type: 'text',
    label: 'Is there a theme?',
    required: false,
  },
  {
    id: 'mkt-materials-vouchers-4',
    subcategoryId: 'mkt-materials-vouchers',
    type: 'textarea',
    label: 'Description',
    required: true,
  },
  {
    id: 'mkt-materials-vouchers-5',
    subcategoryId: 'mkt-materials-vouchers',
    type: 'text',
    label: 'Amount Needed',
    required: true,
  },
  {
    id: 'mkt-materials-vouchers-6',
    subcategoryId: 'mkt-materials-vouchers',
    type: 'date',
    label: 'Needed by',
    required: true,
  },
  {
    id: 'mkt-materials-vouchers-7',
    subcategoryId: 'mkt-materials-vouchers',
    type: 'file',
    label: 'Select A File',
    required: false,
  },
  {
    id: 'mkt-materials-physical-1',
    subcategoryId: 'mkt-materials-physical-flyers',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'mkt-materials-physical-2',
    subcategoryId: 'mkt-materials-physical-flyers',
    type: 'text',
    label: 'What is this needed for',
    required: true,
  },
  {
    id: 'mkt-materials-physical-3',
    subcategoryId: 'mkt-materials-physical-flyers',
    type: 'text',
    label: 'Is there a theme?',
    required: false,
  },
  {
    id: 'mkt-materials-physical-4',
    subcategoryId: 'mkt-materials-physical-flyers',
    type: 'textarea',
    label: 'Description',
    required: true,
  },
  {
    id: 'mkt-materials-physical-5',
    subcategoryId: 'mkt-materials-physical-flyers',
    type: 'text',
    label: 'Amount Needed',
    required: true,
  },
  {
    id: 'mkt-materials-physical-6',
    subcategoryId: 'mkt-materials-physical-flyers',
    type: 'date',
    label: 'Needed by',
    required: true,
  },
  {
    id: 'mkt-materials-physical-7',
    subcategoryId: 'mkt-materials-physical-flyers',
    type: 'file',
    label: 'Select A File',
    required: false,
  },
  {
    id: 'mkt-materials-partnerships-1',
    subcategoryId: 'mkt-materials-partnerships',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'mkt-materials-partnerships-2',
    subcategoryId: 'mkt-materials-partnerships',
    type: 'textarea',
    label: 'Description',
    required: true,
  },
  {
    id: 'mkt-materials-partnerships-3',
    subcategoryId: 'mkt-materials-partnerships',
    type: 'file',
    label: 'Select A File',
    required: false,
  },
  {
    id: 'mkt-materials-email-1',
    subcategoryId: 'mkt-materials-email',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'mkt-materials-email-2',
    subcategoryId: 'mkt-materials-email',
    type: 'text',
    label: 'What is the email for',
    required: true,
  },
  {
    id: 'mkt-materials-email-3',
    subcategoryId: 'mkt-materials-email',
    type: 'date',
    label: 'When does it need to be sent by',
    required: true,
  },
  {
    id: 'mkt-materials-email-4',
    subcategoryId: 'mkt-materials-email',
    type: 'select',
    label: 'Who would you like this sent to',
    required: true,
    options: [
      { value: 'Enrolled', label: 'Enrolled' },
      { value: 'Not Enrolled', label: 'Not Enrolled' },
      { value: 'Both', label: 'Both' },
    ],
  },
  {
    id: 'mkt-materials-email-5',
    subcategoryId: 'mkt-materials-email',
    type: 'textarea',
    label: 'Anything else I need to know',
    required: true,
  },
  {
    id: 'mkt-materials-email-6',
    subcategoryId: 'mkt-materials-email',
    type: 'file',
    label: 'Select A File',
    required: false,
  },
  {
    id: 'mkt-materials-merch-1',
    subcategoryId: 'mkt-materials-merchandise',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'mkt-materials-merch-2',
    subcategoryId: 'mkt-materials-merchandise',
    type: 'textarea',
    label: 'What AEA Branded items would you like',
    required: true,
  },
  {
    id: 'mkt-materials-merch-3',
    subcategoryId: 'mkt-materials-merchandise',
    type: 'text',
    label: 'What is this for',
    required: true,
  },
  {
    id: 'mkt-materials-merch-4',
    subcategoryId: 'mkt-materials-merchandise',
    type: 'date',
    label: 'Date needed by',
    required: true,
  },
  {
    id: 'mkt-materials-merch-5',
    subcategoryId: 'mkt-materials-merchandise',
    type: 'textarea',
    label: 'Anything else I need to know',
    required: true,
  },
  {
    id: 'mkt-materials-merch-6',
    subcategoryId: 'mkt-materials-merchandise',
    type: 'file',
    label: 'Select A File',
    required: false,
  },
];
